import './Loading.scss'

export default function Loading() {
  return <div id="loadingPage">Muntant castell...</div>;
}